export default function insertScript(
  script: HTMLScriptElement,
  callback?: Function
) {
  const firstScript = document.getElementsByTagName(
    'script'
  )[0] as HTMLScriptElement
  const parentNode = firstScript.parentNode as HTMLElement
  const errorMessage = `Error loading asset ${script.getAttribute('src')}`
  parentNode.insertBefore(script, firstScript)
  script.addEventListener('load', () => (callback ? callback() : null))
  script.addEventListener('error', () =>
    callback ? callback(errorMessage) : null
  )
}
